import { render, staticRenderFns } from "./back-top.vue?vue&type=template&id=73f6805f"
import script from "./back-top.vue?vue&type=script&lang=js"
export * from "./back-top.vue?vue&type=script&lang=js"
import style0 from "./back-top.vue?vue&type=style&index=0&id=73f6805f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports